import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { assets, salon, whatsappHref } from '../data/content';
import { useLanguage } from '../contexts/LanguageContext';
import { LanguageToggle } from './LanguageToggle';
import { CloseIcon, InstagramIcon, MenuIcon, TikTokIcon } from './icons/GoldIcons';
export function Navbar() {
  const {
    t
  } = useLanguage();
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const waHref = whatsappHref(t.whatsappMessage);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [open]);
  return <>
      <header className={`sticky top-0 z-40 bg-black transition-[border-color,box-shadow] duration-300 ${scrolled ? 'border-b border-gold-deep/35 shadow-[0_10px_30px_rgba(0,0,0,0.6)]' : 'border-b border-gold-deep/20'}`} data-id="element-255" data-mp="9ohl1o43rnsk">
        <nav aria-label={t.a11y.mainNav} className="mx-auto flex h-24 max-w-7xl items-center justify-between px-5 sm:h-28 sm:px-8" data-id="element-256" data-mp="jm43uloivzht">
        <a href="#inicio" className="flex items-center" aria-label={t.a11y.logo} data-id="element-257" data-mp="okfegymn6e13">
          <img src={assets.logo} alt={t.a11y.logo} className="blend-logo h-20 w-auto object-contain sm:h-24" data-id="element-258" data-mp="3n45j3fwbkci0" />
        </a>

        <ul className="hidden items-center gap-8 lg:flex" data-id="element-259" data-mp="3s2yu91o4vrf0">
          {t.nav.links.map(link => <li key={link.id} data-id="element-260" data-mp="v4h7r4i31rp">
              <a href={`#${link.id}`} className="text-[13px] uppercase tracking-[0.18em] text-neutral-300 transition-colors duration-200 hover:text-gold-bright" data-id="element-261" data-mp="u2uuqi1asuo">
                {link.label}
              </a>
            </li>)}
        </ul>

        <div className="flex items-center gap-3" data-id="element-262" data-mp="39bft70do6nfm">
          <LanguageToggle data-id="element-263" data-mp="39a4rd63sbpr5" />
          <a href={salon.instagramHref} target="_blank" rel="noreferrer" aria-label={t.a11y.instagram} className="hidden rounded-full border border-gold-deep/50 p-2.5 text-gold-soft transition-colors duration-200 hover:border-gold-soft hover:text-gold-ivory sm:block" data-id="element-264" data-mp="31b9uuim4h431">
            <InstagramIcon className="h-5 w-5" strokeWidth={1.5} data-id="element-265" data-mp="3b0b8411a97db" />
          </a>
          <a href={salon.tiktokHref} target="_blank" rel="noreferrer" aria-label={t.a11y.tiktok} className="hidden rounded-full border border-gold-deep/50 p-2.5 text-gold-soft transition-colors duration-200 hover:border-gold-soft hover:text-gold-ivory sm:block" data-id="element-266" data-mp="363b0hlosbwk3">
            <TikTokIcon className="h-5 w-5" strokeWidth={1.5} data-id="element-267" data-mp="2sabkzjp062cj" />
          </a>
          <a href={waHref} target="_blank" rel="noreferrer" className="btn-gold-shine hidden whitespace-nowrap rounded-full px-5 py-2.5 text-[11px] font-semibold uppercase tracking-[0.12em] lg:inline-block" data-id="element-268" data-mp="2s88qamcwnl1h">
            {t.walkIns}
          </a>
          <button type="button" onClick={() => setOpen(true)} className="rounded-full border border-gold-deep/50 p-2.5 text-gold-soft transition-colors duration-200 hover:border-gold-soft hover:text-gold-ivory lg:hidden" aria-label={t.a11y.openMenu} data-id="element-269" data-mp="2k81lylwpoqk">
            <MenuIcon className="h-5 w-5" data-id="element-270" data-mp="f1iuueznxqs5" />
          </button>
        </div>
      </nav>

      </header>

      <AnimatePresence data-id="element-271" data-mp="55pjv01le5ch">
        {open ? <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} style={{
        backgroundColor: '#070605'
      }} className="fixed inset-0 z-[60] overflow-y-auto lg:hidden" data-id="element-272" data-mp="54xonqbwq9mq">
            <div className="flex h-20 items-center justify-between px-5 sm:px-8" data-id="element-273" data-mp="k2giv87ctf1k">
              <img src={assets.logo} alt="" className="blend-logo h-14 w-auto object-contain" data-id="element-274" data-mp="o38v8abiw022" />
              <button type="button" onClick={() => setOpen(false)} className="rounded-full border border-gold-deep/50 p-2.5 text-gold-soft" aria-label={t.a11y.closeMenu} data-id="element-275" data-mp="1bt34yj0jp8i3">
                <CloseIcon className="h-5 w-5" data-id="element-276" data-mp="3p2gk7rehpw9f" />
              </button>
            </div>

            <div className="mt-2 px-6" data-id="element-277" data-mp="3k33yj9zcuv8f">
              <LanguageToggle size="full" data-id="element-278" data-mp="3k22nh5ica8qp" />
            </div>

            <div className="mt-5 flex items-center justify-center gap-4 px-6" data-id="element-279" data-mp="3f3hk4x7sj8y1">
              <a href={salon.instagramHref} target="_blank" rel="noreferrer" aria-label={t.a11y.instagram} className="flex items-center gap-2.5 rounded-full border border-gold-deep/50 px-5 py-3 text-[11px] uppercase tracking-[0.18em] text-gold-soft transition-colors duration-200 hover:border-gold-soft hover:text-gold-ivory" data-id="element-280" data-mp="3f5kj46qx8cew">
                <InstagramIcon className="h-5 w-5" strokeWidth={1.5} data-id="element-281" data-mp="1wpk79x6cj9i" />
                Instagram
              </a>
              <a href={salon.tiktokHref} target="_blank" rel="noreferrer" aria-label={t.a11y.tiktok} className="flex items-center gap-2.5 rounded-full border border-gold-deep/50 px-5 py-3 text-[11px] uppercase tracking-[0.18em] text-gold-soft transition-colors duration-200 hover:border-gold-soft hover:text-gold-ivory" data-id="element-282" data-mp="3tzyvvpjw6pl4">
                <TikTokIcon className="h-5 w-5" strokeWidth={1.5} data-id="element-283" data-mp="28b4mivn50qhf" />
                TikTok
              </a>
            </div>

            <motion.ul initial="hidden" animate="show" variants={{
          hidden: {},
          show: {
            transition: {
              staggerChildren: 0.04,
              delayChildren: 0.05
            }
          }
        }} className="mt-6 flex flex-col gap-2 px-6" data-id="element-284" data-mp="2dahl2dndflzu">
              {t.nav.links.map(link => <motion.li key={link.id} variants={{
            hidden: {
              opacity: 0,
              y: 12
            },
            show: {
              opacity: 1,
              y: 0
            }
          }} transition={{
            duration: 0.25,
            ease: [0.23, 1, 0.32, 1]
          }} data-id="element-285" data-mp="2w7irm2wkpu5w">
                  <a href={`#${link.id}`} onClick={() => setOpen(false)} className="block border-b border-gold-deep/20 py-4 font-display text-2xl text-neutral-200 transition-colors duration-200 hover:text-gold-bright" data-id="element-286" data-mp="39zff1tnarfvy">
                    {link.label}
                  </a>
                </motion.li>)}
            </motion.ul>
            <div className="px-6 pt-8" data-id="element-287" data-mp="19xpfz2rlh1hj">
              <a href={waHref} target="_blank" rel="noreferrer" onClick={() => setOpen(false)} className="btn-gold-shine block rounded-full px-6 py-4 text-center text-[12px] font-semibold uppercase tracking-[0.14em]" data-id="element-288" data-mp="19utdr28prqna">
                {t.walkIns}
              </a>
            </div>
          </motion.div> : null}
      </AnimatePresence>
    </>;
}